/* eslint-disable tree-shaking/no-side-effects-in-initialization */
import {gql} from '@apollo/client'

const SAVE_USER_EXPERIMENTS = /*#__PURE__*/ gql`
  mutation ($experiments: [UserExperimentInput]) {
    saveUserExperiments(experiments: $experiments) {
      userUuid
      experimentId
      variationId
    }
  }
`

export {SAVE_USER_EXPERIMENTS}
